import { format } from "date-fns";

export const waitDelay = (ms) =>
  new Promise((resolve) => setTimeout(resolve, ms));

export const formatDateForStatistics = (dateValue) => {
  if (dateValue == null || dateValue == "" || dateValue == undefined)
    return undefined;
  if (typeof dateValue === "string" && /^\d{4}-\d{2}-\d{2}$/.test(dateValue)) {
    return dateValue;
  }
  const d = dateValue instanceof Date ? dateValue : new Date(dateValue);
  return format(d, "yyyy-MM-dd");
};
